<template>
  <div class="flux-wrap">
    <div class="flux-title">
      <v-icon size="16" color="#ff5722" class="mr-2">mdi-transit-connection-variant</v-icon>
      Flux de aprobare
    </div>
    <div v-if="loading" class="flux-loading">
      <v-progress-circular indeterminate size="20" color="#ff5722" /> Se încarcă…
    </div>
    <div v-else-if="!pasi.length" class="flux-loading">Fără informații de flux.</div>
    <div v-else class="stepper">
      <div v-for="(p, i) in pasi" :key="i" class="step">
        <div class="step-marker">
          <div class="step-ic" :style="{ background: p.color }">
            <v-icon size="16" color="#fff">{{ p.icon }}</v-icon>
          </div>
          <div v-if="!p.last" class="step-line" />
        </div>
        <div class="step-body">
          <div class="step-row">
            <span class="step-rol">{{ p.rol }}</span>
            <span class="step-status" :style="{ color: p.color }">{{ p.statusLabel }}</span>
          </div>
          <div class="step-name">{{ p.nume }}</div>
          <div v-if="p.dataFmt" class="step-meta">{{ p.dataFmt }}</div>
          <div v-if="p.nota" class="step-nota">„{{ p.nota }}"</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PORTAL_CereriConcedii from '@/services/Portal/PORTAL_CereriConcedii'

const STEP_INFO: Record<string, { icon: string; color: string; label: string }> = {
  depusa: { icon: 'mdi-file-send-outline', color: '#2563eb', label: 'Depusă' },
  aprobat: { icon: 'mdi-check-bold', color: '#16a34a', label: 'Confirmat' },
  respins: { icon: 'mdi-close-thick', color: '#dc2626', label: 'Respins' },
  asteptare: { icon: 'mdi-clock-outline', color: '#f59e0b', label: 'În așteptare' },
  anulat: { icon: 'mdi-cancel', color: '#94a3b8', label: 'Anulat' },
}

export default defineComponent({
  name: 'FluxAprobare',
  props: { id: { type: [String, Object], required: true } },
  data() {
    return { loading: true, pasi: [] as any[] }
  },
  async mounted() {
    try {
      const resp = await PORTAL_CereriConcedii.getFlux(String(this.id));
      const raw = resp.data?.Pasi ?? [];
      this.pasi = raw.map((p: any, i: number) => {
        const info = STEP_INFO[p.Status] ?? STEP_INFO.asteptare;
        return {
          rol: p.Rol,
          nume: p.Nume || '—',
          statusLabel: info.label,
          icon: info.icon,
          color: info.color,
          dataFmt: p.Data ? new Date(p.Data).toLocaleString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '',
          nota: p.Nota || '',
          last: i === raw.length - 1,
        };
      });
    } catch {
      this.pasi = [];
    } finally {
      this.loading = false;
    }
  }
})
</script>

<style scoped>
.flux-wrap { padding: 8px 6px 6px; background: #fafbfd; }
.flux-title { font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: .5px; color: #64748b; display: flex; align-items: center; margin-bottom: 14px; }
.flux-loading { display: flex; align-items: center; gap: 10px; color: #94a3b8; font-size: 13px; padding: 6px 0; }
.stepper { display: flex; flex-direction: column; }
.step { display: flex; gap: 14px; }
.step-marker { display: flex; flex-direction: column; align-items: center; }
.step-ic { width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(15,23,42,.12); }
.step-line { flex: 1; width: 2px; background: #e2e8f0; margin: 4px 0; min-height: 22px; }
.step-body { padding-bottom: 18px; }
.step-row { display: flex; align-items: center; gap: 10px; }
.step-rol { font-size: 13px; font-weight: 800; color: #1e293b; }
.step-status { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; }
.step-name { font-size: 13px; color: #475569; margin-top: 1px; }
.step-meta { font-size: 11px; color: #94a3b8; margin-top: 2px; }
.step-nota { font-size: 12px; color: #64748b; font-style: italic; margin-top: 4px; background: #fff; border: 1px solid #eef1f6; border-radius: 8px; padding: 6px 10px; display: inline-block; }
</style>
